var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_144",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 80
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 0.5H80V79.5H1V0.5Z",
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_144)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 29.9999C10.5 28.2318 11.2024 26.5361 12.4526 25.2859C13.7029 24.0356 15.3986 23.3333 17.1667 23.3333H63.8333C65.6014 23.3333 67.2971 24.0356 68.5474 25.2859C69.7976 26.5361 70.5 28.2318 70.5 29.9999V59.9999C70.5 61.768 69.7976 63.4637 68.5474 64.714C67.2971 65.9642 65.6014 66.6666 63.8333 66.6666H17.1667C15.3986 66.6666 13.7029 65.9642 12.4526 64.714C11.2024 63.4637 10.5 61.768 10.5 59.9999V29.9999Z",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8327 10L40.4993 23.3333L27.166 10",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.8f2202e812322e5c3e7e8e5a00c217e5.svg";
export { ForwardRef as ReactComponent };